import React from 'react';
import { RegisterOptions } from 'react-hook-form';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { Copy, Stack } from '@grubhubprod/gh-cookbook-react/dist';
import { CookbookCheckboxWrapper } from 'src/components/CookbookCheckboxWrapper/CookbookCheckboxWrapper';

export interface RestrictionTypeProps {
  name: string;
  text: string;
  value: string;
  description: string;
  rules?: RegisterOptions;
}

export function RestrictionType({
  name,
  text,
  value,
  description,
  rules,
}: RestrictionTypeProps): JSX.Element {
  const { control } = useFormContext();
  return (
    <Stack y="sm">
      <Stack>
        <CookbookCheckboxWrapper
          control={control}
          id={value}
          name={name}
          label={text}
          value={value}
          rules={rules}
        />
      </Stack>
      <Copy variant="caption">{description}</Copy>
    </Stack>
  );
}
